import { render, staticRenderFns } from "./StartupEditSocials.vue?vue&type=template&id=5d53dabe&scoped=true"
import script from "./StartupEditSocials.vue?vue&type=script&setup=true&lang=js"
export * from "./StartupEditSocials.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d53dabe",
  null
  
)

export default component.exports